<template lang="pug">
  #MobileJoinButton
    WtButton.wt-join-button(
      v-if="!showForfeitChallenge"
      :class="{ 'unset-background-color': isText}"
      semibold
      :is-router-link="false"
      :is-text="isText"
      :disabled="disabled"
      :loading="joiningOrRequesting"
      @click.native="joinChallenge"
    )
      template(slot)
        span(:class="joinedClass")
          | {{ joinedStatus }}
        BIcon(
          v-if="isJoined"
          icon="check"
          :class="joinedClass"
        )
    template(v-if="showForfeitChallenge")
      MobileChallengeForfeitActionMenu(:challenge="challenge")
        WtButton.wt-join-button(
          slot="trigger"
          :class="{ 'unset-background-color': isText}"
          semibold
          :is-router-link="false"
          :is-text="isText"
          :loading="joiningOrRequesting"
          @click.native="joinChallenge"
        )
          template(slot)
            span(:class="joinedClass")
              | {{ joinedStatus }}
            BIcon(
              v-if="isJoined"
              icon="check"
              :class="joinedClass"
            )
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import WtButton from "@@/WtButton/WtButton";
import WtTitle from "@@/WtTitle/WtTitle";
import MobileChallengeForfeitActionMenu from "@@/PreventativeChallengeMobile/MobileChallengeForfeitActionMenu";

export default {
  name: "MobileJoinButton",

  components: { WtButton, WtTitle, MobileChallengeForfeitActionMenu },

  props: {
    challenge: {
      type: Object,
      default: null
    },
    isText: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      joiningOrRequesting: false
    };
  },

  computed: {
    ...mapGetters("members", ["mobileChallenges"]),
    ...mapGetters("challenges", ["joining"]),

    showForfeitChallenge() {
      return this.isJoined;
    },

    disabled() {
      if (this.isJoinChallengeButton) {
        return !this.challenge.id || this.joining || this.isNotActive;
      }
      return true;
    },

    isJoinChallengeButton() {
      return this.challenge;
    },

    isJoined() {
      const memberChallengeIds = this.mobileChallenges.map(item => item.id);
      return memberChallengeIds.includes(this.challenge.id);
    },

    joinedStatus() {
      const action = "Join";
      if (this.isJoined) {
        return `${action}ed`;
      }
      return action;
    },

    joinedClass() {
      return this.isJoined ? "has-text-special-success" : "";
    },

    isNotActive() {
      const COMPLETED = 2;
      return this.challenge.status === COMPLETED;
    },

    isTeamAdmin() {
      return this.team.isAdmin;
    }
  },

  methods: {
    ...mapActions(["challenges/mobileJoin"]),
    ...mapActions("members", ["mobileFetchChallenges"]),

    async joinChallenge() {
      if (!this.isJoined) {
        let payload = {
          challenge: this.challenge,
          mobileToken: this.$route.params.mobileToken
        };
        this.joiningOrRequesting = true;

        const response = await this["challenges/mobileJoin"](payload);
        if (response.data.success) {
          await this.mobileFetchChallenges(this.$route.params.mobileToken);
        }
        this.joiningOrRequesting = false;
      }
    }
  }
};
</script>

<style lang="sass" scoped></style>
